var BoundaryStateEnum = /* @__PURE__ */ ((BoundaryStateEnum2) => {
  BoundaryStateEnum2["EMPTY_STATE_IMAGE"] = "empty-state--image";
  BoundaryStateEnum2["EMPTY_STATE_TITLE"] = "empty-state--title";
  BoundaryStateEnum2["EMPTY_STATE_DESCRITION"] = "empty-state--description";
  BoundaryStateEnum2["EMPTY_STATE_BUTTON"] = "empty-state--button";
  BoundaryStateEnum2["ERROR_STATE_IMAGE"] = "error-state--image";
  BoundaryStateEnum2["ERROR_STATE_TITLE"] = "error-state--title";
  BoundaryStateEnum2["ERROR_STATE_DESCRIPTION"] = "error-state--description";
  BoundaryStateEnum2["ERROR_STATE_TRY_AGAIN"] = "error-state--try-again";
  BoundaryStateEnum2["ERROR_STATE_LINK_HOME_PAGE"] = "error-state--home-page";
  return BoundaryStateEnum2;
})(BoundaryStateEnum || {});
export {
  BoundaryStateEnum
};
